module.exports = __webpack_public_path__ + "static/media/avatar1.23908f22.jpeg";